import { Body, Flex, Heading } from '@hover/blueprint';
import React from 'react';

import { PROJECT_DETAILS_PADDING } from 'src/modules/homeownerApp/components/Projects/Project/ProjectCardSection';

type SectionHeaderProps = {
  header: string;
  subHeader: string;
};
export const SectionHeader = ({ header, subHeader }: SectionHeaderProps) => (
  <Flex direction="column" px={PROJECT_DETAILS_PADDING}>
    <Heading m={0} textStyle="heading100">
      {header}
    </Heading>
    <Body color="neutral.500" m={0} textStyle="body300">
      {subHeader}
    </Body>
  </Flex>
);
